import React from 'react';
import classNameBind from 'classnames/bind';
import Popover from '../../../Popover';
import Spinner from '../../../Spinner';
import { TextField } from '../../../TextField';
import SelectionList from '../../SelectionList';
import styles from './SelectionListWrapper.module.css';

const bindClasses = classNameBind.bind(styles);

class SelectionListWrapper extends React.Component {
  componentWillUnmount() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const {
      items,
      onItemSelected,
      multi,
      value,
      selectEvent,
      fixedHeight,
      withPadding,
      isLoading,
      highlight,
      afterListElement,
      search,
      enableSearch,
      onSearchChange,
      isOpen,
      onSearchKeyDown,
      onToggle,
      onHoverElement,
      wrap,
    } = this.props;

    return (
      <div>
        {enableSearch && (
          <Popover.Section padding="narrow">
            <TextField
              name="search"
              icon="search"
              value={search}
              onChange={e => onSearchChange(e, isOpen)}
              clearable
              autoFocus
              onKeyDown={e => onSearchKeyDown(e, onToggle, isOpen)}
            />
          </Popover.Section>
        )}
        <Popover.Section fixedHeight={fixedHeight} padding={withPadding ? 'narrow' : 'none'}>
          {
            isLoading
              ? (
                <div className={bindClasses('wrapper')}>
                  <Spinner className="medium" />
                </div>
              )
              : (
                <SelectionList
                  items={items}
                  onItemSelected={onItemSelected}
                  multi={multi}
                  value={value}
                  selectEvent={selectEvent}
                  highlight={highlight}
                  onHoverElement={onHoverElement}
                  wrap={wrap}
                />
              )
          }
        </Popover.Section>
        {afterListElement}
      </div>
    );
  }
}

SelectionListWrapper.defaultProps = {
  withPadding: false,
  fixedHeight: false,
  highlight: null,
  afterListElement: null,
  search: '',
  enableSearch: false,
  onSearchChange: () => {},
  isOpen: false,
  onSearchKeyDown: () => {},
  onToggle: () => {},
  onClose: null,
  onHoverElement: () => {},
  wrap: false,
};

export default SelectionListWrapper;
